import { authHeaders } from './apiFetch';

export const removeFromCart = async (productId, csrfToken, callback) => {
      try {
          const response = await fetch('/api/user/cart', {
              method: "DELETE",
              headers: authHeaders({
                  "Content-Type": "application/json"
              }),
              body: JSON.stringify({ productId })
          });
          const data = await response.json();
          if (data.success) {
              callback();
          } else {
              // error notify user
          }
      } catch (error) {
          // error notify user
      }
};

export const clearLocalCart = async (csrfToken, callback) => {
    try {
      const response = await fetch('/api/user/cart/clear', {
        method: "DELETE",
        headers: authHeaders({})
      });
      const data = await response.json();
      if (data.success) {
          callback();
      } else {
        // error notify user
      }
    } catch (error) {
      // error notify user
    }
};